export default {"src":"/_next/static/media/burundi.0290fc61.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};